import type { Order } from '../../../gql';

import { extractBranchFromUrl } from '../../url/extractBranchFromUrl';

export const openOrderBomPrint = (orderNumber: Order['orderNumber']): void => {
    const umbrellaBranch = extractBranchFromUrl();
    const branchPrefix = umbrellaBranch ? `/${umbrellaBranch}` : '';
    const printUrl = `${branchPrefix}/print/orders-bom/${orderNumber}`;

    window.open(printUrl, '_blank');
};
